/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 *
 * @author Viacheslav Smalenski
 * @version 1.29.0
 * @since 1.29.0
 */

import dayjs, { Dayjs } from 'dayjs';

export enum EDateFormat {
    DATE_TIME = 'DD.MM.YYYY HH:mm',
    DATE_TIME_SECONDS = 'DD.MM.YYYY HH:mm:ss',
    DATE = 'DD.MM.YYYY',
    SERVER = 'YYYY-MM-DDTHH:mm:ss',
    TIME = 'HH:mm',
}

export const convertDateFormatToOtherDateFormat = (
    date?: Dayjs | Date | string | null,
    incomingFormat?: EDateFormat,
    outgoingFormat?: EDateFormat,
) => {
    const formattedDate = !date ? dayjs() : dayjs(date, incomingFormat);
    return formattedDate.format(outgoingFormat);
};
